import React, {useEffect, useState} from 'react';
import './faqs.css'
import PageHeader from "../../layouts/home/PageHeader";
import {Col, Container, Image, Row} from "react-bootstrap";
import CustomAccordion from "../../components/accesories/accordian/CustomAccordion";
import AOS from 'aos';
import 'aos/dist/aos.css';
import {useData} from "../../context/DataContext";

function FaQs(props) {
    const [items, setItems] = useState([])
    const { data, fetchData, loading } = useData();

    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out', // نوع انیمیشن
            once: true, // فقط یک‌بار انیمیشن اجرا شود
        });
    }, []);

    useEffect(() => {
        if (data.faq.length === 0) {  // چک می‌کنیم که آرایه خالی نباشد
            fetchData("faq", "faq/");
        } else {
            setItems(data.faq)
        }
    }, [data.faq]);
    return (
       <>
           <PageHeader mainTitle={'پرسش های متداول'} currentPage={'پرسش های متداول'}
                       navigationLinks={[{title: 'صفحه اصلی', href: '/'}]}/>

           <Container className={'faq-container'}>
               <Row className={'d-flex align-items-center justify-content-center mt-5'}>
                   <Col sm={12} lg={6} className={'faq-right-col'} data-aos="fade-left">
                       <Image src={'/static/images/man-thinking.gif'}/>
                   </Col>
                   <Col sm={12} lg={6} className={'faq-left-col'} data-aos="fade-right">
                       <CustomAccordion items={items} isFAQ={true}/>
                   </Col>
               </Row>
           </Container>
       </>
    );
}

export default FaQs;